import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import LanguageToggle from './LanguageToggle';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const { t } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Funzione per gestire la navigazione e assicurarsi che la pagina si posizioni all'inizio
  const handleNavigation = () => {
    // Chiude il menu mobile se aperto
    if (mobileMenuOpen) {
      setMobileMenuOpen(false);
    }
    // Scorre la pagina all'inizio
    window.scrollTo(0, 0);
  };

  const handleFaqNavigation = () => {
    if (mobileMenuOpen) {
      setMobileMenuOpen(false);
    }
    
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const faqElement = document.getElementById('faq-section');
        if (faqElement) faqElement.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const faqElement = document.getElementById('faq-section');
      if (faqElement) faqElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="bg-indigo-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2" onClick={handleNavigation}>
              <img 
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1750973984906-Mascotte_testa_1_to_1.png" 
                alt="COSMO Personality Logo" 
                className="h-10 w-10 rounded-full"
              />
              <span className="font-bold text-xl">COSMO Personality</span>
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="hover:text-indigo-200" onClick={handleNavigation}>{t('home')}</Link>
            <Link to="/courses" className="hover:text-indigo-200" onClick={handleNavigation}>{t('courses')}</Link>
            <Link to="/free-resources" className="hover:text-indigo-200" onClick={handleNavigation}>{t('freeResources')}</Link>
            <button onClick={handleFaqNavigation} className="hover:text-indigo-200 transition-colors">{t('faq')}</button>
            <Link to="/about" className="hover:text-indigo-200" onClick={handleNavigation}>
              {t('language') === 'en' ? 'COSMO Team' : 'Team COSMO'}
            </Link>
            <Link to="/contact" className="hover:text-indigo-200" onClick={handleNavigation}>{t('contact')}</Link>
            
            <LanguageToggle />
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button 
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-indigo-200 focus:outline-none"
            >
              {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-indigo-700">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link 
              to="/" 
              className="block px-3 py-2 rounded-md hover:bg-indigo-800"
              onClick={handleNavigation}
            >
              {t('home')}
            </Link>
            <Link 
              to="/courses" 
              className="block px-3 py-2 rounded-md hover:bg-indigo-800"
              onClick={handleNavigation}
            >
              {t('courses')}
            </Link>
            <Link 
              to="/free-resources" 
              className="block px-3 py-2 rounded-md hover:bg-indigo-800"
              onClick={handleNavigation}
            >
              {t('freeResources')}
            </Link>
            <button 
              onClick={handleFaqNavigation}
              className="block w-full text-left px-3 py-2 rounded-md hover:bg-indigo-800"
            >
              {t('faq')}
            </button>
            <Link 
              to="/about" 
              className="block px-3 py-2 rounded-md hover:bg-indigo-800"
              onClick={handleNavigation}
            >
              {t('language') === 'en' ? 'COSMO Team' : 'Team COSMO'}
            </Link>
            <Link 
              to="/contact" 
              className="block px-3 py-2 rounded-md hover:bg-indigo-800"
              onClick={handleNavigation}
            >
              {t('contact')}
            </Link>
            <div className="px-3 py-2">
              <LanguageToggle />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;